import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Heading as RACHeading } from 'react-aria-components';
import { twMerge } from '../../utils/twMerge.js';
/**
 * The `<Heading>` component represent five levels of section headings.
 */
export const Heading = forwardRef(function Heading({ level, visualLevel = level, variant = 'default', isDisabled = false, ...headingProps }, forwardedRef) {
    // react-aria-components heading levels are numeric
    const ariaLevel = Number(level.slice(1));
    return (_jsx(RACHeading, { ...headingProps, ref: forwardedRef, level: ariaLevel, className: twMerge(
        // component name
        `ppl-Heading ppl-Heading--${visualLevel} ppl-Heading--${variant}`, 
        // styles
        isDisabled && 'opacity-40', {
            h1: 'mb-5 font-galano-grotesque text-heading-3xl',
            h2: 'mb-4 font-galano-grotesque text-heading-2xl',
            h3: 'mb-3 font-galano-grotesque text-heading-xl',
            h4: 'mb-3 font-galano-grotesque text-heading-lg',
            h5: 'mb-2 font-galano-grotesque text-heading-md',
            h6: 'mb-2 font-galano-grotesque-alt text-heading-sm',
        }[visualLevel], {
            default: 'text-default',
            subdued: 'text-default-subdued',
            warning: 'text-warning',
            critical: 'text-critical',
            inverse: 'text-inverse-default',
        }[variant], 
        // user classes
        headingProps.className) }));
});
//# sourceMappingURL=Heading.js.map